/* eslint-disable @typescript-eslint/no-explicit-any */
import {CreateInviteRequest} from "../model/request/invite/CreateInviteRequest.ts";
import {BaseService} from "./BaseService.ts";
import {VerifyInviteRequest} from "../model/request/invite/VerifyInviteRequest.ts";
import {InviteRegistrationRequest} from "@/model/request/invite/InviteRegistrationRequest.ts";
import {ResendPendingInviteRequest} from "@/model/request/invite/ResendPendingInviteRequest.ts";

export class InviteService {
    static invite = (others: any, data: CreateInviteRequest) => {
        return BaseService.apiClient(others).post("/invite/create", data);
    };
    static readInvite = (others: any) => {
        return BaseService.apiClient(others).get("/invite/read");
    };
    static verifyInvite = (others: any, data: VerifyInviteRequest) => {
        return BaseService.apiClient(others).get("/invite/verify-invite/" + data?.inviteId)
    }
    static inviteRegistration = (others: any, data: InviteRegistrationRequest) => {
        return BaseService.apiClient(others).post(`invite/invite-registration`, data)
    }
    static resendInvite = (others: any, data: ResendPendingInviteRequest) => {
        return BaseService.apiClient(others).post(`invite/resend-pending-invite`, data)
    }
}
